
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13120',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13120",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9905",
  "foundations-components": "static-1.8388",
  "foundations-components-legacy": "static-1.1413",
  "foundations-theming": "static-1.4705",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8276",
  "hub-http-shared-msw-handlers": "static-1.10528",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11732",
  "I18n": "static-7.1661",
  "jasmine-runner": "static-1.6697",
  "marketplace-discovery-studio-lib": "static-1.552",
  "marketplace-storefront-base": "static-1.13183",
  "quartz": "static-1.7368",
  "react-dlb": "static-1.85",
  "react-rhumb": "static-1.16958",
  "reactive-variable-buffer-atom": "static-1.3104",
  "reporting-testing-lib": "static-1.10518",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12769",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7558",
  "ui-addon-i18n": "static-1.11394",
  "ui-addon-react-router-dom": "static-1.9785",
  "unified-auth": "static-1.804",
  "unified-auth-core-lib": "static-1.1086",
  "usage-tracker": "static-1.7605",
  "usage-tracker-core": "static-1.7455",
  "customer-data-property-utils": "static-1.8347",
  "hub-http": "static-1.6461",
  "integrations-lib": "static-1.16928",
  "marketplace-ui-common": "static-1.20603",
  "marketplace-ui-install": "static-1.589",
  "property-management-iframe": "static-1.13993",
  "quartz-config": "static-1.1146",
  "quartz-core": "static-1.6587",
  "quartz-routing": "static-1.798",
  "quick-fetch": "static-1.4095",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4911",
  "ts-schema": "static-1.4257",
  "ui-universal-auth": "static-1.9290",
  "UIComponents": "static-3.8678",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3579",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3645",
  "quartz-webpack": "static-1.3592",
  "bend-plugin-quartz-routing": "static-1.446",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4657",
  "floating-ui": "static-1.62",
  "foundations-assets": "static-1.5125",
  "foundations-theming-specialty": "static-1.2421",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9675",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.60",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5518",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.495",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2472",
  "ui-fonts": "static-1.994",
  "ui-images": "static-2.1229",
  "bend-plugin-foundations-theming": "static-1.3188",
  "foundations-theming-base": "static-1.3690",
  "stylex": "static-1.38",
  "HeadJS": "static-2.789",
  "hs-test-utils-bend-plugin": "static-1.3387",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4567",
  "ui-addon-video-player": "static-1.8953",
  "ai-components-ui-library": "static-1.9586",
  "ai-rendering-library": "static-1.11003",
  "chirp-fetch": "static-1.2139",
  "connections-embed-lib": "static-1.1430",
  "copilot-toolkit": "static-1.11745",
  "feedback-loader": "static-1.29736",
  "laboratory-lib": "static-3.7401",
  "marketplace-embed": "static-1.22818",
  "marketplace-ui-details": "static-1.10498",
  "marketplace-ui-reviews": "static-1.20558",
  "marketplace-ui-tracking": "static-1.14773",
  "sanitize-text": "static-1.8398",
  "usage-tracker-multi": "static-1.6019",
  "usage-tracker-session-replay": "static-1.5291",
  "wootric-nps": "static-1.7163",
  "quartz-head": "static-1.1033",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4905",
  "immer": "static-1.94",
  "immerable": "static-1.4400",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68585",
  "cssUtils": "static-1.870",
  "flux-actions": "static-1.360",
  "HubStyle": "static-2.12039",
  "PatternValidationJS": "static-1.3145",
  "react-colorpicker": "static-2.10456",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10615",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7595",
  "icons": "static-2.674",
  "marketplace-ui-apps-core": "static-1.19135",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4759",
  "foundations-components-test-utils": "static-1.5871",
  "quartz-i18n": "static-1.1043",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.355",
  "ads-unified-auth-lib": "static-1.1048",
  "google-sheets-integration-lib": "static-1.931",
  "microsoft-drive-auth-lib": "static-1.22",
  "surveymonkey-integration-lib": "static-1.375",
  "slack-ui-library": "static-1.10646",
  "fsm": "static-1.3988",
  "customer-data-objects": "static-1.7936",
  "property-translator": "static-1.5643",
  "hs-locale-management": "static-1.257",
  "frontend-preferences-client": "static-1.8176",
  "hs-promise-utils": "static-1.5845",
  "hubspot-apollo-client": "static-1.5127",
  "integrations-error-boundary-lib": "static-1.14343",
  "integrations-tracking-lib": "static-1.5856",
  "native-integrations-shared-strings": "static-1.8026",
  "sanitize": "static-1.4724",
  "superstore": "static-1.5006",
  "ui-shepherd-react": "static-3.10512",
  "ai-settings-ui-library": "static-1.8256",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4827",
  "immutable-less": "static-1.4900",
  "marketplace-ui-client-types": "static-1.18010",
  "nav-meta": "static-1.30354",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18321",
  "ui-product-approvals-common": "static-1.883",
  "ai-studio-lib": "static-1.12361",
  "hubspot-prosemirror": "static-1.18871",
  "integrations-reconnect-lib": "static-1.403",
  "ui-addon-iframeable": "static-1.9325",
  "ui-addon-integrations-directory-panel": "static-2.8275",
  "ui-product-approvals": "static-1.28988",
  "ui-tool-access": "static-1.10402",
  "inbound-db-properties-service-client": "static-1.4020",
  "property-management-common": "static-1.6281",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1043",
  "quartz-test": "static-1.1043",
  "quartz-tracking": "static-1.747",
  "trellis-components": "static-1.2491",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.321",
  "bender-build-tools": "static-1.3358",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22639",
  "ContentUtils": "static-1.69056",
  "customer-data-objects-ui-components": "static-1.13279",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2746",
  "breeze-engine-core": "static-1.850",
  "breeze-onboarding-components": "static-1.613",
  "customer-data-filters-ui": "static-1.40761",
  "customer-data-reference-ui-components": "static-1.13429",
  "embedded-academy-lib": "static-1.15352",
  "ExportDialog": "static-6.10629",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41910",
  "reporting-snowflake": "static-1.57203",
  "reporting-ui-components": "static-2.65856",
  "reporting-visualizations": "static-1.60661",
  "trial-components-library": "static-1.14024",
  "trellis-theming": "static-1.1209",
  "ui-addon-teams": "static-1.21854",
  "upgrade-components-lib": "static-1.457",
  "magpie-lib": "static-1.5720",
  "navigation-components": "static-1.18717",
  "breeze-engine-lib": "static-1.1572",
  "magpie-types": "static-1.5180",
  "simple-logging-lib": "static-1.3298",
  "fail-safe": "static-1.203",
  "app-governance-lib": "static-1.2294",
  "developer-experience-shared-components": "static-1.10749",
  "purchase-motions-components": "static-1.6284",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10044",
  "usage-tracker-anonymous": "static-1.6022",
  "usage-tracker-public": "static-1.7416",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3949",
  "reference-resolvers": "static-1.8431",
  "ui-extensibility-client-types": "static-1.4169",
  "hubspot-apollo-cache": "static-1.586",
  "universal-page-editor-lib": "static-1.3257",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3437",
  "atom": "static-1.5333",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10889",
  "ui-addon-draggable": "static-3.5005",
  "content-assistance-lib": "static-1.8132",
  "content-media-capture": "static-1.5312",
  "customer-data-ui-utilities": "static-1.10075",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24364",
  "growth-payments-core": "static-1.26074",
  "knowledge-content-types": "static-1.8618",
  "payment-link-components": "static-1.24078",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20237",
  "ui-addon-emoji-picker": "static-1.10134",
  "ui-business-units-lib": "static-1.9332",
  "video-components-external": "static-1.12058",
  "video-data-lib": "static-1.35716",
  "navigation-messaging": "static-1.8044",
  "collaboration-sidebar": "static-1.58608",
  "react-dnd-compat": "static-1.4865",
  "batch-promise": "static-1.1792",
  "crm-component-utils": "static-1.39730",
  "crm-properties-common-lib": "static-1.6138",
  "customer-data-properties": "static-1.52433",
  "external-options-client-types": "static-1.4303",
  "framework-data-schema-resolvers": "static-1.7142",
  "property-value-citations": "static-1.3047",
  "reference-resolvers-lite": "static-1.8348",
  "hubspotter-http-shared-msw-handlers": "static-1.10526",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5064",
  "content-icons-ui": "static-1.2312",
  "breeze-artifacts-sdk": "static-1.190",
  "onboarding-journeys-lib": "static-1.780",
  "pulse": "static-1.875",
  "conversations-skeleton-state": "static-1.7497",
  "crm-message-bus": "static-1.43642",
  "customer-data-filters-ui-msw-helpers": "static-1.23196",
  "events-data-lib": "static-1.491",
  "FormUrlGenerator": "static-2.4975",
  "framework-builder-read-service-client": "static-1.4184",
  "hs-resources": "static-1.439",
  "multi-account-reference-resolvers": "static-1.1245",
  "onboarding-scopes": "static-1.6705",
  "onboarding-tours": "static-1.17040",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14367",
  "academy-common-lib": "static-1.14812",
  "dashboard-lib": "static-1.82634",
  "getting-started-shared-tasks": "static-1.19115",
  "hubspot-prosemirror-plugins": "static-1.18863",
  "share-with-third-party-component-lib": "static-1.8953",
  "ui-asset-management-lib": "static-1.11345",
  "user-context": "static-1.5361",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68263",
  "hubs-service-types": "static-1.1506",
  "purchase-motions-api": "static-1.6287",
  "signup-constants": "static-1.19498",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.970",
  "nest": "static-1.485",
  "breeze-engine-chat-components": "static-1.550",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.154",
  "framework-listing-lib": "static-2.29376",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31319",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4504",
  "signup-ui-url-generator": "static-2.8307",
  "onboarding-tours-client": "static-1.5254",
  "one-click-checkout": "static-1.307",
  "platform-infra-nav-components": "static-1.7850",
  "subscription-experience-data-types": "static-1.15201",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.9991",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29214",
  "content-media-composition-data-lib": "static-1.13116",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4673",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.613",
  "ui-addon-opt": "static-4.8613",
  "commerce-tours-lib": "static-1.6536",
  "growth-onboarding-reliability": "static-1.5329",
  "sales-checkout-service-client": "static-1.3779",
  "data-token-picker": "static-1.16815",
  "FileManagerLib": "static-1.40004",
  "content-media-compositions": "static-2.17123",
  "media-bridge-lib": "static-1.19336",
  "chatspot-widget-iframe": "static-1.22630",
  "collaboration-sidebar-common": "static-1.3405",
  "marketing-platform-lib": "static-1.7118",
  "card-properties-lib": "static-1.44904",
  "commerce-subscription-lib": "static-1.37680",
  "crm-actions": "static-1.6601",
  "crm-cards-sdk": "static-1.44382",
  "customer-data-properties-shared-msw-handlers": "static-1.9855",
  "customer-data-tracking": "static-1.7130",
  "calling-global-api": "static-1.65372",
  "calling-internal-common": "static-1.31564",
  "calling-lifecycle-internal": "static-1.66754",
  "calling-lifecycle-messages": "static-1.59048",
  "commerce-products-lib": "static-1.10408",
  "conditional-properties-service-client": "static-1.3977",
  "crm-index-visualization-core": "static-1.4476",
  "crm-links": "static-1.6571",
  "crm-pipelines-api-client-types": "static-1.4311",
  "formula-editor": "static-1.14677",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4388",
  "meetings-icalendar-utils-lib": "static-1.885",
  "multi-currency-client-types": "static-1.3871",
  "object-builder-ui-client": "static-1.49533",
  "pipeline-validation-client-types": "static-1.4146",
  "smart-property-lib": "static-1.8167",
  "tiered-pricing": "static-1.1860",
  "topics-actions-lib": "static-1.409",
  "ui-addon-form-validation": "static-1.11234",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.261",
  "framework-data-schema-quick-fetch": "static-1.7047",
  "bend-plugin-pulse": "static-1.378",
  "event-emitter": "static-1.1202",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1557",
  "growth-data-modal": "static-1.5820",
  "growth-onboarding-confetti": "static-1.3310",
  "growth-onboarding-next-action-utils": "static-1.2596",
  "onboarding-tours-utils": "static-1.1106",
  "ui-shepherd-tracker": "static-1.7893",
  "academy-service-client": "static-1.3938",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39863",
  "SafeStorage": "static-1.4653",
  "video-embed": "static-1.36550",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24916",
  "viral-links-lib": "static-1.7323",
  "nested-table": "static-1.482",
  "timezone-utils": "static-2.5497",
  "getting-started-shared-tasks-store": "static-1.18233",
  "campaign-roi-lib": "static-1.9998",
  "ui-addon-calendars": "static-2.5576",
  "customer-data-views-management": "static-1.25932",
  "framework-data-table": "static-2.12446",
  "nudge-client-utils": "static-1.3069",
  "nudge-custom-ui-functions": "static-1.1419",
  "switchboard-lib": "static-1.464",
  "access-check-ui-lib": "static-1.1486",
  "app-users-service-client": "static-1.5866",
  "app-users-service-types": "static-1.5274",
  "mini-checkout-client": "static-1.27402",
  "onboarding-utils": "static-1.5610",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29199",
  "checkout-sdk": "static-3.24245",
  "payment-method-components": "static-1.7096",
  "touchless-buying-components": "static-1.6113",
  "upgrade-catalog-service-types": "static-1.3734",
  "edison-service-client-types": "static-1.640",
  "growth-onboarding-feedback-components": "static-1.6832",
  "audio-components": "static-1.6274",
  "FileManagerImages": "static-1.37515",
  "video-components": "static-1.14060",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92728",
  "customer-data-sidebar": "static-2.46645",
  "enrichment-properties-lib": "static-1.17788",
  "ui-addon-draggable-compat": "static-2.4511",
  "universal-record-utils-lib": "static-1.1742",
  "commerce-billing-lib": "static-1.19989",
  "commerce-shared-components-lib": "static-1.19130",
  "commerce-tools-ui-lib": "static-1.10959",
  "crm-fe-perf": "static-1.23149",
  "calling-error-reporting": "static-1.31571",
  "shared-worker-versioning": "static-1.11289",
  "calling-usage-tracker": "static-1.6786",
  "voice-sms-access-library": "static-1.1911",
  "commerce-permissions": "static-1.1025",
  "products-iframe-lib": "static-1.8499",
  "products-ui-components-shared-msw-handlers": "static-1.10910",
  "crm-index-associations-lib": "static-1.6691",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10611",
  "sales-views-client-types": "static-1.4505",
  "bark-lib": "static-1.16754",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.575",
  "policy-lib": "static-1.7043",
  "react-tinymce": "static-1.55876",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10674",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55002",
  "tinymce-plugins": "static-1.58116",
  "tinymce-themes": "static-1.56972",
  "onboarding-data-sync-lib": "static-1.2411",
  "growth-onboarding-next-action-components": "static-1.2624",
  "user-context-client": "static-1.4755",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4782",
  "outpost": "static-1.4410",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22085",
  "sales-email-signature-service-client": "static-1.4094",
  "ts-utils-lib": "static-1.424",
  "crm-export-dialog": "static-1.6534",
  "crm-view-components": "static-1.1001",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7578",
  "nudge-custom-function-registry": "static-1.2826",
  "nudge-renderer-utils": "static-1.3145",
  "whisper-core-api": "static-1.7230",
  "InboxConnectUtils": "static-4.15459",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46747",
  "hub-http-rxjs": "static-1.832",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4240",
  "company-details-components": "static-1.6448",
  "react-performance-metrics-lib": "static-1.804",
  "pricing-pages-ui-components": "static-1.15500",
  "quote-checkout-service-types": "static-1.3704",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22426",
  "customer-data-email": "static-1.18452",
  "card-payment-highlight-lib": "static-1.37874",
  "card-subscription-highlight-lib": "static-1.40103",
  "commerce-contract-lib": "static-1.13144",
  "invoices-highlight-card-lib": "static-1.55553",
  "orders-highlight-card-lib": "static-1.22093",
  "products-highlight-card-lib": "static-1.18691",
  "quotes-highlight-card-lib": "static-1.72741",
  "crm-source-interpretation-lib": "static-1.5581",
  "data-agent-utils": "static-1.183",
  "crm-object-search-query-utilities": "static-1.10114",
  "utility-belt": "static-1.2780",
  "payments-enrollment-embed-lib": "static-1.23702",
  "stripe-embedded-components": "static-1.7926",
  "customer-data-rte": "static-1.33562",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6194",
  "payments-post-enroll-local-storage-lib": "static-1.5354",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38831",
  "calling-orchestration-schema": "static-1.36688",
  "react-reducer-toolkit": "static-1.16266",
  "hub-http-contrib": "static-1.3287",
  "interframe": "static-3.5006",
  "tinymce-data": "static-1.41087",
  "ui-addon-sales-email": "static-1.5463",
  "layout-dnd-components": "static-1.12892",
  "layout-dnd-utils": "static-1.11867",
  "ui-brand-identity-lib": "static-1.16222",
  "NamespacedHubStyle": "static-2.9226",
  "meetings-connect-utils-lib": "static-1.7857",
  "access-control-lib": "static-1.10685",
  "EmailComponents": "static-1.55453",
  "EmailData": "static-1.54131",
  "redux-less": "static-2.9728",
  "company-details-service-types": "static-1.4188",
  "segments-query-core": "static-1.1673",
  "pricing-pages-api": "static-1.15365",
  "sequences-lib": "static-1.8466",
  "ui-gdpr-components": "static-1.10603",
  "products-ui-components": "static-1.40926",
  "accounting-integrations-ui-components": "static-1.7466",
  "invoices-ui-lib": "static-1.55569",
  "commerce-products-api": "static-1.2638",
  "invoices-iframe-lib": "static-1.57627",
  "quotes-modal-lib": "static-1.103419",
  "quotes-ui-lib": "static-1.81462",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28825",
  "ContentData": "static-1.69131",
  "layout-data-lib": "static-1.10192",
  "ContentComponents": "static-2.72012",
  "marketing-contacts-lib": "static-1.10885",
  "marketing-email-service-types": "static-1.2065",
  "messaging-editing-lib": "static-1.47031",
  "messaging-usage-based-billing-components-lib": "static-1.1893",
  "automation-ui-source-apps": "static-1.19564",
  "automation-ui-types": "static-1.20482",
  "messaging-types-lib": "static-1.46768",
  "onboarding-settings-client": "static-1.4758",
  "sequences-client-types-lib": "static-1.8323",
  "commerce-tax-lib": "static-1.789",
  "price-books-api": "static-1.1632",
  "price-books-components": "static-1.1690",
  "property-description-translator": "static-1.4087",
  "ramp-editor": "static-1.794",
  "commerce-analytics-service-client": "static-1.3767",
  "totals-ui-components": "static-1.24207",
  "SalesContentIndexUI": "static-3.9570",
  "advanced-menus-core": "static-1.15511",
  "advanced-menus-lib": "static-1.12392",
  "ui-memberships-settings-lib": "static-1.34719",
  "automation-ui-ubb": "static-1.6398",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7585",
  "data-token-views": "static-1.16796",
  "forms-utils-lib": "static-1.13020",
  "payments-embed-points-lib": "static-1.13510",
  "simple-menus-core": "static-1.15510",
  "simple-menus-lib": "static-1.17027",
  "videoconference-integration-components": "static-1.7176",
  "marketing-contacts-client": "static-1.7757",
  "mc-hard-limits-client-types": "static-1.151",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77802",
  "short-messages-app-service-client": "static-1.4167",
  "web-interactives-components": "static-1.14176",
  "web-interactives-data": "static-1.14177",
  "messaging-shared-utils-lib": "static-1.1342",
  "messaging-user-info-utils-lib": "static-1.1512",
  "email-portal-health-service-types": "static-1.1226",
  "line-items-api": "static-1.1037",
  "commerce-totals-service-types": "static-1.3995",
  "FireAlarmUi": "static-1.4683",
  "sales-templates-service-types-lib": "static-1.4347",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22418",
  "automation-ui-usage-tracking": "static-1.21881",
  "data-studio-ubb": "static-1.3411",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27568",
  "content-management-data-lib": "static-1.5873",
  "copilot-plugins": "static-1.11717",
  "cta-picker": "static-1.36995",
  "customer-agent-discovery-components-lib": "static-1.3783",
  "editor-components": "static-1.13578",
  "editor-iframe-lib": "static-1.8733",
  "error-messaging-js": "static-1.5444",
  "FormsCommonComponents": "static-1.86478",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10898",
  "SharedLegalStrings": "static-1.1995",
  "smart-content-core": "static-1.43078",
  "smart-content-lib": "static-1.43731",
  "social-composer-lib": "static-1.60085",
  "structured-content-lib": "static-1.25823",
  "theme-previewer-lib": "static-1.53852",
  "tinymce-copilot": "static-1.17070",
  "xray-recommendation-lib": "static-1.8209",
  "automation-ui-routing": "static-1.21839",
  "sql-reporting-client-types": "static-1.5849",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42700",
  "campaigns-utils-lib": "static-1.3449",
  "reporting-enablement": "static-1.23721",
  "forms-ai-lib": "static-1.4689",
  "codemirror-dlb": "static-1.59361",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6688",
  "report-customization-components": "static-1.13801",
  "data-quality-ui-library": "static-1.13680",
  "reporting-filters": "static-1.913",
  "reporting-insights-lib": "static-1.2465"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13120",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9905",
  "foundations-components": "/foundations-components/static-1.8388",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1413",
  "foundations-theming": "/foundations-theming/static-1.4705",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8276",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10528",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11732",
  "I18n": "/I18n/static-7.1661",
  "jasmine-runner": "/jasmine-runner/static-1.6697",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.552",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13183",
  "quartz": "/quartz/static-1.7368",
  "react-dlb": "/react-dlb/static-1.85",
  "react-rhumb": "/react-rhumb/static-1.16958",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3104",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10518",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12769",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7558",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11394",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9785",
  "unified-auth": "/unified-auth/static-1.804",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1086",
  "usage-tracker": "/usage-tracker/static-1.7605",
  "usage-tracker-core": "/usage-tracker-core/static-1.7455",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8347",
  "hub-http": "/hub-http/static-1.6461",
  "integrations-lib": "/integrations-lib/static-1.16928",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20603",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.589",
  "property-management-iframe": "/property-management-iframe/static-1.13993",
  "quartz-config": "/quartz-config/static-1.1146",
  "quartz-core": "/quartz-core/static-1.6587",
  "quartz-routing": "/quartz-routing/static-1.798",
  "quick-fetch": "/quick-fetch/static-1.4095",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4911",
  "ts-schema": "/ts-schema/static-1.4257",
  "ui-universal-auth": "/ui-universal-auth/static-1.9290",
  "UIComponents": "/UIComponents/static-3.8678",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3579",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3645",
  "quartz-webpack": "/quartz-webpack/static-1.3592",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.446",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4657",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-assets": "/foundations-assets/static-1.5125",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2421",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9675",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5518",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2472",
  "ui-fonts": "/ui-fonts/static-1.994",
  "ui-images": "/ui-images/static-2.1229",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3188",
  "foundations-theming-base": "/foundations-theming-base/static-1.3690",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.789",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3387",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4567",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8953",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9586",
  "ai-rendering-library": "/ai-rendering-library/static-1.11003",
  "chirp-fetch": "/chirp-fetch/static-1.2139",
  "connections-embed-lib": "/connections-embed-lib/static-1.1430",
  "copilot-toolkit": "/copilot-toolkit/static-1.11745",
  "feedback-loader": "/feedback-loader/static-1.29736",
  "laboratory-lib": "/laboratory-lib/static-3.7401",
  "marketplace-embed": "/marketplace-embed/static-1.22818",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10498",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20558",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14773",
  "sanitize-text": "/sanitize-text/static-1.8398",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6019",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5291",
  "wootric-nps": "/wootric-nps/static-1.7163",
  "quartz-head": "/quartz-head/static-1.1033",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4905",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4400",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68585",
  "cssUtils": "/cssUtils/static-1.870",
  "flux-actions": "/flux-actions/static-1.360",
  "HubStyle": "/HubStyle/static-2.12039",
  "PatternValidationJS": "/PatternValidationJS/static-1.3145",
  "react-colorpicker": "/react-colorpicker/static-2.10456",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10615",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7595",
  "icons": "/icons/static-2.674",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19135",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4759",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5871",
  "quartz-i18n": "/quartz-i18n/static-1.1043",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.355",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1048",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.931",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.22",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.375",
  "slack-ui-library": "/slack-ui-library/static-1.10646",
  "fsm": "/fsm/static-1.3988",
  "customer-data-objects": "/customer-data-objects/static-1.7936",
  "property-translator": "/property-translator/static-1.5643",
  "hs-locale-management": "/hs-locale-management/static-1.257",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8176",
  "hs-promise-utils": "/hs-promise-utils/static-1.5845",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5127",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14343",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5856",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8026",
  "sanitize": "/sanitize/static-1.4724",
  "superstore": "/superstore/static-1.5006",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10512",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8256",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4827",
  "immutable-less": "/immutable-less/static-1.4900",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18010",
  "nav-meta": "/nav-meta/static-1.30354",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18321",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.883",
  "ai-studio-lib": "/ai-studio-lib/static-1.12361",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18871",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.403",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9325",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8275",
  "ui-product-approvals": "/ui-product-approvals/static-1.28988",
  "ui-tool-access": "/ui-tool-access/static-1.10402",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4020",
  "property-management-common": "/property-management-common/static-1.6281",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1043",
  "quartz-test": "/quartz-test/static-1.1043",
  "quartz-tracking": "/quartz-tracking/static-1.747",
  "trellis-components": "/trellis-components/static-1.2491",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.321",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22639",
  "ContentUtils": "/ContentUtils/static-1.69056",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13279",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2746",
  "breeze-engine-core": "/breeze-engine-core/static-1.850",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.613",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40761",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13429",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15352",
  "ExportDialog": "/ExportDialog/static-6.10629",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41910",
  "reporting-snowflake": "/reporting-snowflake/static-1.57203",
  "reporting-ui-components": "/reporting-ui-components/static-2.65856",
  "reporting-visualizations": "/reporting-visualizations/static-1.60661",
  "trial-components-library": "/trial-components-library/static-1.14024",
  "trellis-theming": "/trellis-theming/static-1.1209",
  "ui-addon-teams": "/ui-addon-teams/static-1.21854",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.457",
  "magpie-lib": "/magpie-lib/static-1.5720",
  "navigation-components": "/navigation-components/static-1.18717",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1572",
  "magpie-types": "/magpie-types/static-1.5180",
  "simple-logging-lib": "/simple-logging-lib/static-1.3298",
  "fail-safe": "/fail-safe/static-1.203",
  "app-governance-lib": "/app-governance-lib/static-1.2294",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10749",
  "purchase-motions-components": "/purchase-motions-components/static-1.6284",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10044",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6022",
  "usage-tracker-public": "/usage-tracker-public/static-1.7416",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3949",
  "reference-resolvers": "/reference-resolvers/static-1.8431",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4169",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.586",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3257",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3437",
  "atom": "/atom/static-1.5333",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10889",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5005",
  "content-assistance-lib": "/content-assistance-lib/static-1.8132",
  "content-media-capture": "/content-media-capture/static-1.5312",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10075",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24364",
  "growth-payments-core": "/growth-payments-core/static-1.26074",
  "knowledge-content-types": "/knowledge-content-types/static-1.8618",
  "payment-link-components": "/payment-link-components/static-1.24078",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20237",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10134",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9332",
  "video-components-external": "/video-components-external/static-1.12058",
  "video-data-lib": "/video-data-lib/static-1.35716",
  "navigation-messaging": "/navigation-messaging/static-1.8044",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58608",
  "react-dnd-compat": "/react-dnd-compat/static-1.4865",
  "batch-promise": "/batch-promise/static-1.1792",
  "crm-component-utils": "/crm-component-utils/static-1.39730",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6138",
  "customer-data-properties": "/customer-data-properties/static-1.52433",
  "external-options-client-types": "/external-options-client-types/static-1.4303",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7142",
  "property-value-citations": "/property-value-citations/static-1.3047",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8348",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10526",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5064",
  "content-icons-ui": "/content-icons-ui/static-1.2312",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.190",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.780",
  "pulse": "/pulse/static-1.875",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7497",
  "crm-message-bus": "/crm-message-bus/static-1.43642",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23196",
  "events-data-lib": "/events-data-lib/static-1.491",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4975",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4184",
  "hs-resources": "/hs-resources/static-1.439",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1245",
  "onboarding-scopes": "/onboarding-scopes/static-1.6705",
  "onboarding-tours": "/onboarding-tours/static-1.17040",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14367",
  "academy-common-lib": "/academy-common-lib/static-1.14812",
  "dashboard-lib": "/dashboard-lib/static-1.82634",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19115",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18863",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8953",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11345",
  "user-context": "/user-context/static-1.5361",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68263",
  "hubs-service-types": "/hubs-service-types/static-1.1506",
  "purchase-motions-api": "/purchase-motions-api/static-1.6287",
  "signup-constants": "/signup-constants/static-1.19498",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.970",
  "nest": "/nest/static-1.485",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.550",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.154",
  "framework-listing-lib": "/framework-listing-lib/static-2.29376",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31319",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4504",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8307",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5254",
  "one-click-checkout": "/one-click-checkout/static-1.307",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7850",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15201",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9991",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29214",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13116",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4673",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.613",
  "ui-addon-opt": "/ui-addon-opt/static-4.8613",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6536",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5329",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "data-token-picker": "/data-token-picker/static-1.16815",
  "FileManagerLib": "/FileManagerLib/static-1.40004",
  "content-media-compositions": "/content-media-compositions/static-2.17123",
  "media-bridge-lib": "/media-bridge-lib/static-1.19336",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22630",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3405",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7118",
  "card-properties-lib": "/card-properties-lib/static-1.44904",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37680",
  "crm-actions": "/crm-actions/static-1.6601",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44382",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9855",
  "customer-data-tracking": "/customer-data-tracking/static-1.7130",
  "calling-global-api": "/calling-global-api/static-1.65372",
  "calling-internal-common": "/calling-internal-common/static-1.31564",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66754",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59048",
  "commerce-products-lib": "/commerce-products-lib/static-1.10408",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3977",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4476",
  "crm-links": "/crm-links/static-1.6571",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4311",
  "formula-editor": "/formula-editor/static-1.14677",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4388",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.885",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3871",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49533",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4146",
  "smart-property-lib": "/smart-property-lib/static-1.8167",
  "tiered-pricing": "/tiered-pricing/static-1.1860",
  "topics-actions-lib": "/topics-actions-lib/static-1.409",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11234",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.261",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7047",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.378",
  "event-emitter": "/event-emitter/static-1.1202",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1557",
  "growth-data-modal": "/growth-data-modal/static-1.5820",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3310",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2596",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1106",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7893",
  "academy-service-client": "/academy-service-client/static-1.3938",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39863",
  "SafeStorage": "/SafeStorage/static-1.4653",
  "video-embed": "/video-embed/static-1.36550",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24916",
  "viral-links-lib": "/viral-links-lib/static-1.7323",
  "nested-table": "/nested-table/static-1.482",
  "timezone-utils": "/timezone-utils/static-2.5497",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18233",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9998",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5576",
  "customer-data-views-management": "/customer-data-views-management/static-1.25932",
  "framework-data-table": "/framework-data-table/static-2.12446",
  "nudge-client-utils": "/nudge-client-utils/static-1.3069",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1419",
  "switchboard-lib": "/switchboard-lib/static-1.464",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1486",
  "app-users-service-client": "/app-users-service-client/static-1.5866",
  "app-users-service-types": "/app-users-service-types/static-1.5274",
  "mini-checkout-client": "/mini-checkout-client/static-1.27402",
  "onboarding-utils": "/onboarding-utils/static-1.5610",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29199",
  "checkout-sdk": "/checkout-sdk/static-3.24245",
  "payment-method-components": "/payment-method-components/static-1.7096",
  "touchless-buying-components": "/touchless-buying-components/static-1.6113",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3734",
  "edison-service-client-types": "/edison-service-client-types/static-1.640",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6832",
  "audio-components": "/audio-components/static-1.6274",
  "FileManagerImages": "/FileManagerImages/static-1.37515",
  "video-components": "/video-components/static-1.14060",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92728",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46645",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17788",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4511",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1742",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19989",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19130",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10959",
  "crm-fe-perf": "/crm-fe-perf/static-1.23149",
  "calling-error-reporting": "/calling-error-reporting/static-1.31571",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11289",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6786",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1911",
  "commerce-permissions": "/commerce-permissions/static-1.1025",
  "products-iframe-lib": "/products-iframe-lib/static-1.8499",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10910",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6691",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10611",
  "sales-views-client-types": "/sales-views-client-types/static-1.4505",
  "bark-lib": "/bark-lib/static-1.16754",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.575",
  "policy-lib": "/policy-lib/static-1.7043",
  "react-tinymce": "/react-tinymce/static-1.55876",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10674",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55002",
  "tinymce-plugins": "/tinymce-plugins/static-1.58116",
  "tinymce-themes": "/tinymce-themes/static-1.56972",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2411",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2624",
  "user-context-client": "/user-context-client/static-1.4755",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4782",
  "outpost": "/outpost/static-1.4410",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22085",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4094",
  "ts-utils-lib": "/ts-utils-lib/static-1.424",
  "crm-export-dialog": "/crm-export-dialog/static-1.6534",
  "crm-view-components": "/crm-view-components/static-1.1001",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7578",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2826",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3145",
  "whisper-core-api": "/whisper-core-api/static-1.7230",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15459",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46747",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.832",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4240",
  "company-details-components": "/company-details-components/static-1.6448",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.804",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15500",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3704",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22426",
  "customer-data-email": "/customer-data-email/static-1.18452",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37874",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40103",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13144",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55553",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22093",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18691",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72741",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5581",
  "data-agent-utils": "/data-agent-utils/static-1.183",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10114",
  "utility-belt": "/utility-belt/static-1.2780",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23702",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7926",
  "customer-data-rte": "/customer-data-rte/static-1.33562",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6194",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5354",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38831",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36688",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16266",
  "hub-http-contrib": "/hub-http-contrib/static-1.3287",
  "interframe": "/interframe/static-3.5006",
  "tinymce-data": "/tinymce-data/static-1.41087",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5463",
  "layout-dnd-components": "/layout-dnd-components/static-1.12892",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11867",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16222",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9226",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7857",
  "access-control-lib": "/access-control-lib/static-1.10685",
  "EmailComponents": "/EmailComponents/static-1.55453",
  "EmailData": "/EmailData/static-1.54131",
  "redux-less": "/redux-less/static-2.9728",
  "company-details-service-types": "/company-details-service-types/static-1.4188",
  "segments-query-core": "/segments-query-core/static-1.1673",
  "pricing-pages-api": "/pricing-pages-api/static-1.15365",
  "sequences-lib": "/sequences-lib/static-1.8466",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10603",
  "products-ui-components": "/products-ui-components/static-1.40926",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7466",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55569",
  "commerce-products-api": "/commerce-products-api/static-1.2638",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57627",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103419",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81462",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28825",
  "ContentData": "/ContentData/static-1.69131",
  "layout-data-lib": "/layout-data-lib/static-1.10192",
  "ContentComponents": "/ContentComponents/static-2.72012",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10885",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2065",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47031",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1893",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19564",
  "automation-ui-types": "/automation-ui-types/static-1.20482",
  "messaging-types-lib": "/messaging-types-lib/static-1.46768",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4758",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8323",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.789",
  "price-books-api": "/price-books-api/static-1.1632",
  "price-books-components": "/price-books-components/static-1.1690",
  "property-description-translator": "/property-description-translator/static-1.4087",
  "ramp-editor": "/ramp-editor/static-1.794",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3767",
  "totals-ui-components": "/totals-ui-components/static-1.24207",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9570",
  "advanced-menus-core": "/advanced-menus-core/static-1.15511",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12392",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34719",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6398",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7585",
  "data-token-views": "/data-token-views/static-1.16796",
  "forms-utils-lib": "/forms-utils-lib/static-1.13020",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13510",
  "simple-menus-core": "/simple-menus-core/static-1.15510",
  "simple-menus-lib": "/simple-menus-lib/static-1.17027",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7176",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7757",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.151",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77802",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4167",
  "web-interactives-components": "/web-interactives-components/static-1.14176",
  "web-interactives-data": "/web-interactives-data/static-1.14177",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1342",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1512",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1226",
  "line-items-api": "/line-items-api/static-1.1037",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3995",
  "FireAlarmUi": "/FireAlarmUi/static-1.4683",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4347",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22418",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21881",
  "data-studio-ubb": "/data-studio-ubb/static-1.3411",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27568",
  "content-management-data-lib": "/content-management-data-lib/static-1.5873",
  "copilot-plugins": "/copilot-plugins/static-1.11717",
  "cta-picker": "/cta-picker/static-1.36995",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3783",
  "editor-components": "/editor-components/static-1.13578",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8733",
  "error-messaging-js": "/error-messaging-js/static-1.5444",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10898",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1995",
  "smart-content-core": "/smart-content-core/static-1.43078",
  "smart-content-lib": "/smart-content-lib/static-1.43731",
  "social-composer-lib": "/social-composer-lib/static-1.60085",
  "structured-content-lib": "/structured-content-lib/static-1.25823",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53852",
  "tinymce-copilot": "/tinymce-copilot/static-1.17070",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8209",
  "automation-ui-routing": "/automation-ui-routing/static-1.21839",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5849",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42700",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3449",
  "reporting-enablement": "/reporting-enablement/static-1.23721",
  "forms-ai-lib": "/forms-ai-lib/static-1.4689",
  "codemirror-dlb": "/codemirror-dlb/static-1.59361",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6688",
  "report-customization-components": "/report-customization-components/static-1.13801",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13680",
  "reporting-filters": "/reporting-filters/static-1.913",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2465"
}
};
